import { inject, Pipe, PipeTransform } from '@angular/core';
import { AssetDto } from '@nusign/picflow-backend-types';
import { baseZoom } from '../../consts';
import { canDisplayAsset } from '../../lib/can-display-asset';
import { AssetDisplayService } from '../../services/asset-display.service';

@Pipe({
  name: 'scale',
  standalone: true,
  pure: false,
})
export class ScalePipe implements PipeTransform {
  private assetDisplayService = inject(AssetDisplayService);
  transform(asset: AssetDto, offsetScale: number): number {
    if (asset.type !== 'image' && asset.type !== 'document') return baseZoom;
    if (!canDisplayAsset(asset)) return baseZoom;
    return this.assetDisplayService.getBaseZoom(offsetScale, baseZoom);
  }
}
